import Config from 'services/config/config';
import callWebService, { callTypes } from 'services/utils/networks/network';
import { GO_LIVE_SITE, GO_LIVE_FILTER } from './type';

export const fetchGoLiveSites = (filterData = null, page = 1) => async (
  dispatch
) => {
  const res = await callWebService(
    callTypes.get,
    '',
    filterData === null? `${Config.maintenance.fetchGoLiveSites}?page=${page}`: `${Config.maintenance.fetchGoLiveSites}?site_no=${filterData.site_no}&client_name=${filterData.client_name}&site_type=${filterData.site_type}&assignee_id=${filterData.assignee_ids}&commercial_type_id=${filterData.commercial_type_id}&page=${page}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: GO_LIVE_SITE,
      payload: data.response.data,
    });
    return true;
  }
};

export const getGOLiveFilterDropDown = () => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.maintenance.goLiveFilterDropDown}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: GO_LIVE_FILTER,
      payload: data.response.data,
    });
    return true;
  }
};

export const postGoLiveAssignee = (requestData) => async () => {
  const res = await callWebService(
    callTypes.post,
    requestData,
    Config.maintenance.goLiveChangeAssignee
  );
  if (res) {
    return true;
  } else {
    return null;
  }
};
